<h4 class="title ml-20px pt-20px">QR Generator</h4>
<mat-card class="create-field field mt-30px">
  <form class="d-flex row m-4 mb-0" [formGroup]="qrCodeForm" (ngSubmit)="generateQrCode()">
    <app-filled-form-field class="hashtag-input-form col-4 col-lg-3 col-md-2 col-sm-6 mt-3 ms-auto"
                           [label]="'Qty *'"
                           [formControlName]="'qty'"
                           [errorMessage]="QTY_ERROR_MESSAGE"
                           [isControlInvalid]="qrCodeForm.get('qty')?.invalid && qrCodeForm.get('qty')?.touched">
    </app-filled-form-field>
    <button type="submit" mat-button class="save-btn col-lg-2 mt-4">
      <div class="admin-add-icon-and-text">
        <mat-icon class="add-icon-hashtag">add</mat-icon>
        Generate QR code
      </div>
    </button>
  </form>
  <mat-card-content class="mb-7px">
    <div class="tabs-container">
      <button type="button" class="tab-button" [class.active]="activeTab === TAB_ACTIVE" (click)="setActiveTab(TAB_ACTIVE)">Active ({{ activeCount }})</button>
      <button type="button" class="tab-button" [class.active]="activeTab === TAB_INACTIVE" (click)="setActiveTab(TAB_INACTIVE)">Inactive ({{ inactiveCount }})</button>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="hashtag-info-text hashtags-info-container">
        QR codes per page / {{ getFilteredQrCodesCount() }}
      </div>
      @if (getFilteredQrCodes().length) {
        <button type="button" mat-button (click)="downloadAllQRCodesAsPDF()" [disabled]="isLoading">
          <div>
            <img src="assets/svg/download.svg">
          </div>
        </button>
      }
    </div>
    <div class="line-container"></div>
    <div class="qr-grid">
      <div *ngFor="let qrCode of getFilteredQrCodes()" class="qr-content">
        <div class="model" [ngClass]="{ 'disabled-model': qrCode.isUsed }">
          <div class="d-flex justify-content-end me-4">
            <div class="qr-download-button" (click)="downloadImage(qrCode.qrCode, qrCode.qrUsername)">
              <img src="assets/svg/download.svg" alt="">
            </div>
          </div>
          <img [src]="getQr(qrCode.qrCode)" alt="QR Code" class="qr-code-image width-50">
        </div>
        <span class="qr-content info">{{ qrCode.qrUsername }}</span>
        @if (qrCode.isUsed) {
          <div class="center-button-wrapper">
            <button type="submit" (click)="goToUserCard(qrCode.userCardQrUsername)" mat-button
                    class="save-btn mt-2">
              Go to user card
            </button>
          </div>
        }
      </div>
    </div>
    <div class="pagination">
      @if (getFilteredQrCodes().length) {
        <a (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 0">&laquo;</a>
        <a *ngFor="let page of getPageNumbers()"
           (click)="goToPage(page - 1)"
           [class.active]="currentPage === (page - 1)">
          {{ page }}
        </a>
        <a (click)="goToPage(currentPage + 1)" [class.disabled]="currentPage === totalPages - 1">&raquo;</a>
      }
    </div>
  </mat-card-content>
</mat-card>
